<template>
  <div class="score">{{ $t('QUESTION_FORM.YOUR_SCORE') }} {{ userScore }} / {{ totalScore }}</div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'user-score',
  props: {

  },
  computed: {
    ...mapGetters({ userScore: 'userScore', totalScore: 'totalScore'})
  },
};
</script>

<style lang="scss" scoped>
.score {
  text-align: center;
  font-size: 20px;
  font-weight: bold;
  padding-top: 25px;
}
</style>
